export const sidebarOptions = {
  regions: [
    { field: "region", value: "", label: "All" },
    { field: "region", value: "Asia ex-Japan", label: "Asia ex-Japan" },
    { field: "region", value: "Americas", label: "Americas" },
    { field: "region", value: "EMEA", label: "EMEA" },
    { field: "region", value: "Japan", label: "Japan" },
  ],
  Macro: [
    { value: "", label: "All" },
    { value: "Credit", label: "Credit" },
    { value: "ESG", label: "ESG" },
    { value: "Economics", label: "Economics" },
    { value: "Equity Strategy", label: "Equity Strategy2" },
    { value: "FX Strategy", label: "FX Strategy" },
    { value: "Macro Strategy", label: "Macro Strategy" },
    { value: "Quantitative Strategies", label: "Quantitative Strategies" },
    { value: "Rates Strategy", label: "Rates Strategy" },
    { value: "Securitized Products", label: "Securitized Products" },
  ],
  Equity: [
    { value: "", label: "All" },
    { value: "Auto & Auto Parts", label: "Auto & Auto Parts" },
    { value: "Basic Materials", label: "Basic Materials" },
    { value: "Consumer", label: "Consumer" },
    { value: "Energy / Utilities", label: "Energy / Utilities" },
    { value: "Financials", label: "Financials" },
    { value: "Healthcare & Pharmaceuticals", label: "Healthcare & Pharmaceuticals" },
    { value: "Industrials", label: "Industrials2" },
    { value: "Information Technology", label: "Information Technology" },
    { value: "Property", label: "Property" },
    { value: "Small- & Mid-Cap Stocks", label: "Small- & Mid-Cap Stocks" },
    { value: "Technology (Electronics)", label: "Technology (Electronics)" },
  ],
};
